module.exports = __webpack_public_path__ + "static/media/veg-burger.9e658d39.png";